/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_3_DetailInputs */

const en_services_svc_money_art_3_detail = /** @type {(inputs: Services_Svc_Money_Art_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales owner approves before sending`)
};

const lv_services_svc_money_art_3_detail = /** @type {(inputs: Services_Svc_Money_Art_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārdošanas atbildīgais apstiprina pirms sūtīšanas`)
};

/**
* | output |
* | --- |
* | "Sales owner approves before sending" |
*
* @param {Services_Svc_Money_Art_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_3_detail = /** @type {((inputs?: Services_Svc_Money_Art_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_3_detail(inputs)
	return en_services_svc_money_art_3_detail(inputs)
});